import React, { useState } from 'react';

// Universal Button Component
const Button = ({
  text = 'Button',
  children,
  variant = 'default',
  onClick = () => {},
  style: customStyle = {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const baseStyle = {
    padding: '5px 15px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  };

  const variantStyles = {
    primary: {
      backgroundColor: 'orange',
      color: '#fff',
    },
    secondary: {
      backgroundColor: '#6c757d',
      color: '#fff',
    },
    success: {
      backgroundColor: '#28a745',
      color: '#fff',
    },
    danger: {
      backgroundColor: '#dc3545',
      color: '#fff',
    },
    warning: {
      backgroundColor: '#ffc107',
      color: '#212529',
    },
    outline: {
      backgroundColor: 'transparent',
      color: '#007bff',
      border: '1px solid #007bff',
    },
    circle: {
      backgroundColor: '#fff',
      color: '#000',
      borderRadius: '50%',
      padding: '10px',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
    },
    default: {
      backgroundColor: '#f8f9fa',
      color: '#212529',
      border: '1px solid #ced4da',
    },
  };

  const focusStyle = {
    backgroundColor: 'rgba(230, 230, 230, 0.5)',
  };

  const style = {
    ...baseStyle,
    ...(variantStyles[variant] || variantStyles.default),
    ...(variant === 'circle' && isFocused ? focusStyle : {}),
    ...customStyle, // Merge custom styles here
  };

  return (
    <button
      style={style}
      onClick={onClick}
      {...props}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      {children || text}
    </button>
  );
};

export default Button;
